export default import.meta.ROLLDOWN_FILE_URL_zYsVCnrAtTlaxTYG3FQt_A